exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreementCheckbox__label___3n3fV {\n  margin-bottom: 8px; }\n  .agreementCheckbox__label___3n3fV + .agreementCheckbox__label___3n3fV {\n    margin-left: 0; }\n  .agreementCheckbox__label___3n3fV .agreementCheckbox__text___21-_n::after {\n    content: '*';\n    display: inline-block;\n    color: #f5222d;\n    margin-left: 4px; }\n", ""]);

// exports
exports.locals = {
	"label": "agreementCheckbox__label___3n3fV",
	"text": "agreementCheckbox__text___21-_n"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/AgreementSection/AgreementCheckbox/agreementCheckbox.scss
// module id = 4527
// module chunks = 6